import { theme } from '@notino/react-styleguide'
import styled from 'styled-components'
import { resetButtonStyles } from '../../../../styles/helpers'

export const ServicesTabsWrapper = styled.div`
	margin-bottom: 60px;
`

export const TabsContainer = styled.div`
	position: relative;
	isolation: isolate;
`

export const Tabs = styled.ul`
	display: flex;
	overflow-x: auto;
	scroll-behavior: smooth;
	z-index: 0;

	/* hide scrollbar */
	&::-webkit-scrollbar {
		display: none; // for Chrome, Safari and Opera
	}
	& {
		-ms-overflow-style: none; // for IE and Edge
		scrollbar-width: none; // for for Firefox
	}
`

export const Tab = styled.li`
	list-style: none;
	padding: 0;
	margin: 0;

	&::before {
		display: none; // override Notino main app styles
	}
`

export const TabButton = styled.button`
	${resetButtonStyles};
	/* Match previous div tabs: buttons do not inherit typography by default */
	font: inherit;
	cursor: pointer;
	padding: 8px 16px;
	white-space: nowrap;
	color: ${theme.color.text.tertiary};
	border-bottom: 2px solid ${theme.color.border.disabled};
	outline: 2px solid transparent;
	/* Inset so the ring is not clipped by the scrollable tablist overflow */
	outline-offset: -2px;

	&[aria-selected='true'] {
		position: relative;
		color: ${theme.color.text.primary};
		border-color: ${theme.color.border.selected};
		font-weight: 500;
	}

	&:focus-visible {
		outline-color: ${theme.color.border.selected};
	}
`

export const TabsContent = styled.div`
	position: relative;
`

export const TabContent = styled.div`
	position: relative;
	padding: 32px 0 12px 0;
`

export const ScrollButton = styled.button`
	${resetButtonStyles};

	border: transparent;
	position: absolute;
	top: 0;
	width: 40px;
	height: 40px;
	padding: 5px 8px 10px 8px;
	background-color: white;

	&::after {
		content: '';
		display: block;
		width: 20px;
		height: 100%;
		position: absolute;
		top: 0;
		bottom: 0;
	}
`

export const ScrollLeftButton = styled(ScrollButton)`
	left: 0;

	&::after {
		left: 100%;
		background: linear-gradient(to right, white, transparent);
	}
`

export const ScrollRightButton = styled(ScrollButton)`
	right: 0;

	&::after {
		right: 100%;
		background: linear-gradient(to left, white, transparent);
	}
`
